var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('md-dialog-confirm',{ref:"confirm",attrs:{"md-title":_vm.title,"md-content-html":_vm.content},on:{"open":_vm.onOpen,"close":_vm.close}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }